var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('div',{staticClass:"main"},[_c('div',{staticClass:"contenter"},[_c('div',{staticClass:"menu"},[_c('main-menu')],1),_c('app-main')],1),_c('div',{staticClass:"bottom"},[_c('bottom')],1)])])])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }